import ChartGraph from "utils/Charts/ChartGraph/ChartGraph";
import { mostActiveDaysOption } from "./data";

const MostActiveDays = () => {
	return (
		<div className="pt-1">
			<ChartGraph
				option={mostActiveDaysOption}
				styles={{
					height: "361px",
				}}
			/>
		</div>
	);
};

export default MostActiveDays;
